/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Concurrency_FailureInputs */

const nl_auth_password_errors_concurrency_failure = /** @type {(inputs: Auth_Password_Errors_Concurrency_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is een gelijktijdigheidsfout opgetreden. Probeer het opnieuw.`)
};

/**

* @param {Auth_Password_Errors_Concurrency_FailureInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_concurrency_failure = /** @type {((inputs?: Auth_Password_Errors_Concurrency_FailureInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Concurrency_FailureInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_concurrency_failure(inputs)
});
export { auth_password_errors_concurrency_failure as "auth.password_errors.concurrency_failure" }